import { render, staticRenderFns } from "./CartReviewTicket.vue?vue&type=template&id=1e068582&scoped=true&"
import script from "./CartReviewTicket.vue?vue&type=script&lang=ts&"
export * from "./CartReviewTicket.vue?vue&type=script&lang=ts&"
import style0 from "./CartReviewTicket.vue?vue&type=style&index=0&id=1e068582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e068582",
  null
  
)

export default component.exports